import { Injectable, EventEmitter, signal } from '@angular/core';

/** Emitted whenever something outside the widget (e.g. Quick Search's "Ask Linc" card) wants
 *  the chat drawer opened with a question pre-filled — mirrors the isMenuExpanded EventEmitter
 *  pattern in SideBarMenuSharedService. AiChatWidgetComponent is the sole subscriber (it's
 *  mounted once, globally, in app.component.html). */
@Injectable({ providedIn: 'root' })
export class AiChatWidgetSharedService {
  openWithQuestion = new EventEmitter<string>();

  /** 2026-10-07: "Ask Linc" in the profile menu (the round Linc / Support button was hidden). Opens the chat as it is, no question pre-filled. */
  openRequested = new EventEmitter<void>();

  /** True only while Linc AI help is switched on for this company (set by AppComponent from the bootstrap answer). The profile menu shows "Ask Linc" only then; false until known. */
  readonly enabled = signal(false);

  requestOpen(): void {
    this.openRequested.emit();
  }

  requestOpenWithQuestion(question: string): void {
    this.openWithQuestion.emit(question);
  }
}
